export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5137.7741e936.jpg";